import {html, ref} from "../../../../admin/script/libs/lit.dist.js";
import chatTemplate from "./chat-template.js";

const showChatAnimated = el => {
    if (el) {
        setTimeout(() => {
            el.classList.remove('pk-user-chat--hidden')
        }, 20);
    }
};

const addClassAfter = (el, classNames, timeout = 0, removeAfterTimeout = 0) => {
    if (el) {
        setTimeout(() => {
            for (let className of classNames) {
                el.classList.add(className);
            }
            if (removeAfterTimeout) {
                setTimeout(() => {
                    for (let className of classNames) {
                        el.classList.remove(className);
                    }
                }, removeAfterTimeout);
            }
        }, timeout);
    }
}

export default (props) => html`
    <div class="pk-chat-button-container ${props.isChatVisible ? 'chat-visible' : 'chat-hidden'}">
        ${props.buttonLabel ? html`
            <span class="badge text-bg-light shadow rounded-pill px-3 py-2 border border-primary cursor-pointer pk-chat-button-label" @click="${props.toggleChat}">
                ${props.buttonLabel}
            </span>
        ` : null}
        <button 
            class="btn btn-primary pk-chat-button shadow ${props.isChatVisible ? 'chat-visible' : 'chat-hidden'}" 
            @click="${props.toggleChat}"
            @keydown="${e => e.key === 'Escape' && props.closeChat()}"
            title="${props.isChatVisible ? 'Minimalizuj czat' : 'Otwórz czat'}"
        >
            ${props.unreadMessagesCount > 0 ? html`
                <i class="bi bi-envelope"></i> ${props.unreadMessagesCount}
                <i ${ref(el => addClassAfter(el, ['pk-pulse-animation', 'pk-animation-3x'], 100))}></i>
            ` : html`
                ${!props.isChatVisible ? html`
                    <i class="bi bi-chat-left-text-fill"></i>
                ` : html`
                    <i class="bi bi-chevron-bar-down"></i>
                `}
            `}
            <i class="pk-chat-toggle-button-pulse" aria-hidden="true"></i>
        </button>
    </div>
    ${props.isChatVisible ? html`
        <div 
            role="dialog" 
            tabindex="0"
            aria-modal="true" 
            class="card mb-3 pk-user-chat shadow pk-user-chat--hidden" 
            ${ref(el => showChatAnimated(el))}
            @keydown="${e => e.key === 'Escape' && props.closeChat()}"
        >
            <div class="card-body h-100 fs-sm">
                ${chatTemplate(props)}
            </div>
        </div>
    ` : null}
`;
